var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "detail-wrap" }, [
    _c(
      "div",
      { staticClass: "yto-box", staticStyle: { "padding-top": "10px" } },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            attrs: { inline: true, model: _vm.form, "label-width": "100px" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "dateType" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "y-w-160",
                    attrs: { "popper-append-to-body": false },
                    model: {
                      value: _vm.form.dateType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dateType", $$v)
                      },
                      expression: "form.dateType",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "取号时间", value: "0" },
                    }),
                    _c("el-option", {
                      attrs: { label: "操作回收时间", value: "1" },
                    }),
                    _c("el-option", {
                      attrs: { label: "回收时间", value: "2" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "createTime" } },
              [
                _c("yto-date-picker", {
                  staticClass: "y-w-320",
                  attrs: {
                    customDaysName: "facesheetRecyclingPDetail",
                    curShortcutName: _vm.curShortcutName,
                    maxRangeVal: 31,
                    "picker-options": _vm.pickerOptions,
                    clearable: false,
                    editable: false,
                    "default-time": ["00:00:00", "23:59:59"],
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                    format: "yyyy.MM.dd HH:mm",
                    type: "datetimerange",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.form.createTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "createTime", $$v)
                    },
                    expression: "form.createTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "platformCode" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "y-w-160",
                    attrs: {
                      clearable: "",
                      "popper-append-to-body": false,
                      placeholder: "请选择平台",
                    },
                    on: { change: _vm.getPlatformMallList },
                    model: {
                      value: _vm.form.platformCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "platformCode", $$v)
                      },
                      expression: "form.platformCode",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "抖音", value: "LUBAN" },
                    }),
                    _c("el-option", {
                      attrs: { label: "拼多多", value: "PDD" },
                    }),
                    _c("el-option", { attrs: { label: "快手", value: "KS" } }),
                    _c("el-option", {
                      attrs: { label: "淘宝", value: "TAOBAO" },
                    }),
                    _c("el-option", {
                      attrs: { label: "1688", value: "ALI_1688" },
                    }),
                    _c("el-option", { attrs: { label: "京东", value: "JD" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "orderMallCode" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "y-w-160",
                    attrs: {
                      clearable: "",
                      disabled: !_vm.form.platformCode,
                      "popper-append-to-body": false,
                      placeholder: "请选择店铺",
                    },
                    model: {
                      value: _vm.form.orderMallCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderMallCode", $$v)
                      },
                      expression: "form.orderMallCode",
                    },
                  },
                  _vm._l(_vm.shopList, function (item) {
                    return _c("el-option", {
                      key: item.mallCode,
                      attrs: { label: item.mallName, value: item.mallCode },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "cpCode" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "y-w-160",
                    attrs: {
                      clearable: "",
                      "popper-append-to-body": false,
                      placeholder: "请选择快递公司",
                    },
                    model: {
                      value: _vm.form.cpCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cpCode", $$v)
                      },
                      expression: "form.cpCode",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "圆通速递", value: "YTO" },
                    }),
                    _c("el-option", {
                      attrs: { label: "中通速递", value: "ZTO" },
                    }),
                    _c("el-option", {
                      attrs: { label: "韵达快递", value: "YUNDA" },
                    }),
                    _c("el-option", {
                      attrs: { label: "申通快递", value: "STO" },
                    }),
                    _c("el-option", {
                      attrs: { label: "顺丰速运", value: "SF" },
                    }),
                    _c("el-option", { attrs: { label: "EMS", value: "EMS" } }),
                    _c("el-option", {
                      attrs: { label: "邮政快递包裹", value: "YZKDBG" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "recycleStatus" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "y-w-160",
                    attrs: {
                      clearable: "",
                      "popper-append-to-body": false,
                      placeholder: "请选择单号状态",
                    },
                    model: {
                      value: _vm.form.recycleStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recycleStatus", $$v)
                      },
                      expression: "form.recycleStatus",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "回收中", value: "0" } }),
                    _c("el-option", { attrs: { label: "已回收", value: "1" } }),
                    _c("el-option", {
                      attrs: { label: "平台回收成功", value: "2" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c("waybill-input", {
                  attrs: { placeholder: "请输入运单号" },
                  model: {
                    value: _vm.form.mailNos,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "mailNos", $$v)
                    },
                    expression: "form.mailNos",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "y-f-r" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.searchClick },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "normal-btn",
                    attrs: { icon: "el-icon-refresh-left" },
                    on: {
                      click: function ($event) {
                        return _vm.resetForm("ruleForm")
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "yto-table" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { data: _vm.tableData, height: "calc(100vh - 300px)" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "mailNo", label: "运单号" },
            }),
            _c("el-table-column", {
              attrs: { label: "单号类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.WAYBILLNAMEMAP[scope.row.mailType]) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "waybillAccountName", label: "运单所属店铺" },
            }),
            _c("el-table-column", {
              attrs: { prop: "orderNo", label: "订单号" },
            }),
            _c("el-table-column", {
              attrs: { label: "平台类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.PLATFORMNAMEMAP[scope.row.platformCode]) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "orderMallName", label: "订单所属店铺" },
            }),
            _c("el-table-column", {
              attrs: { label: "快递公司" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.CPCODEMAP[scope.row.cpCode]) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "单号状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.recycleStatus === 0
                              ? "回收中"
                              : scope.row.recycleStatus === 1
                              ? "已回收"
                              : "平台回收成功"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "opertionRecycleTime", label: "操作回收时间" },
            }),
            _c("el-table-column", {
              attrs: { prop: "fetchWaybillTime", label: "取号时间" },
            }),
            _c("el-table-column", {
              attrs: { prop: "recycleTime", label: "回收时间" },
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.pageNum,
            "page-sizes": [50, 100, 200, 300, 400],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.limitChange,
            "current-change": _vm.getDataList,
            "update:currentPage": function ($event) {
              _vm.pageNum = $event
            },
            "update:current-page": function ($event) {
              _vm.pageNum = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }